import React, { useEffect, useState } from "react";
import {
    AppBar,
    Button,
    Card,
    Toolbar,
    Typography,
} from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";

const ViewAndEditFormLayout = ({
    viewTitle,
    editTitle,
    initialEdit,
    onSave,
    onDelete,
    showDeleteInEdit = false,
    onCancel,
    editContent,
    viewContent,
}) => {
    const [isEditing, setIsEditing] = useState(initialEdit);

    useEffect(() => {
        setIsEditing(initialEdit);
    }, [initialEdit]);

    const hasViewContent = !!viewContent;
    const hasEditContent = !!editContent;
    const canView = hasViewContent;

    const handleCancel = () => {
        if (isEditing) {
            if (canView) {
                setIsEditing(false);
            } else if (onCancel) {
                onCancel();
            }
            return;
        }
        if (onCancel) {
            onCancel();
        }
    };

    const handleSave = () => {
        if (!onSave) return;
        const result = onSave();
        const applyResult = (action) => {
            if (action === "view" && canView) {
                setIsEditing(false);
            } else if (action === "close" && onCancel) {
                onCancel();
            }
        };
        if (result && typeof result.then === "function") {
            result.then(applyResult);
        } else {
            applyResult(result);
        }
    };

    const handleDelete = () => {
        if (onDelete) {
            onDelete();
        }
    };

    const resolvedTitle = isEditing ? editTitle : viewTitle;
    const shouldDeleteButton = !!onDelete;
    const showEditBlock = !isEditing;
    const showDeleteButton = shouldDeleteButton && (!isEditing || showDeleteInEdit);

    const renderContent = (content) => {
        if (typeof content === "function") {
            return content({
                isEditing,
                onCancel: handleCancel,
                onSave: handleSave,
                setIsEditing,
            });
        }
        return content;
    };

    if ((isEditing && !hasEditContent) || (!isEditing && !hasViewContent)) {
        return null;
    }

    return (
        <Card className="EditCard">
            <AppBar position="static">
                <Toolbar variant="regular">
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                        {resolvedTitle}
                    </Typography>
                    {showEditBlock && (
                        <Button color="inherit" onClick={() => setIsEditing(true)}>
                            <Edit />
                        </Button>
                    )}
                    {showDeleteButton && (
                        <Button color="inherit" onClick={handleDelete}>
                            <Delete />
                        </Button>
                    )}
                </Toolbar>
            </AppBar>
            {isEditing ? renderContent(editContent) : renderContent(viewContent)}
        </Card>
    );
};

export default ViewAndEditFormLayout;
